import { PermissionAccess } from '@wizeoo/akm-common-lib';
import { StaticFeatureEnum, PermissionVisibility } from '@wizeoo/akm-common-lib';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { WIZ_EVENT_TYPE, IWizTranslationEntry } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizTranslationBasic,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { FreedataLevelVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

/**
 * rendu d'un niveau de FD-Level
 */
@Component({
  selector: 'fd-level-renderer',
  templateUrl: './fd-level.renderer.html',
})
export class FDLevelRenderer implements AfterViewInit, OnDestroy, IWizItemRenderer<null, FreedataLevelVO> {
  @HostBinding('style.width') elwidth: string = '100%';

  @ViewChild('fdlevelTrans', { read: WizTranslationBasic }) fdlevelTrans: WizTranslationBasic;

  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  private _data: FreedataLevelVO;
  public updatedEntry: IWizTranslationEntry = null;

  /**
   * Sets the data that needs to be rendered
   */
  @Input() public set data(value: FreedataLevelVO) {
    this._data = value;
    this.cdref.markForCheck();
  }

  public get data(): FreedataLevelVO {
    return this._data;
  }

  ngAfterViewInit() {
    this.fdlevelTrans.wizLabel =
      WizTranslationManager.getInstance().translateKey('$.freedatalevel.label.$') + ' ' + this.data.level;
    this.fdlevelTrans.translationData = Model.getInstance().localeEngine.buildTranslationData(this.data.labelVO);

    this.fdlevelTrans.wizDisabled = !Model.getInstance().permissionEngine.hasAnyPermission({
      feature: StaticFeatureEnum.FREEDATA,
      visibility: PermissionVisibility.DISABLED,
      accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
    });

    WizEventManager.addListener(this, this.fdlevelTrans, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
  }

  ngOnDestroy() {
    if (!!this.fdlevelTrans) {
      // sinon, c'est qu'il est détruit avant le afterInit
      WizEventManager.removeListener(this, this.fdlevelTrans, WIZ_EVENT_TYPE.MODEL_UPDATE);
    }
  }

  private updateModel(e: WizEvent): void {
    this.updatedEntry = e.value;
    WizEventManager.dispatchEvent(this, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, null, this));
  }
}
